import type { MedVisitCitation } from "@/services/medChronServiceV2.types";

export const getCitationKey = (citation: MedVisitCitation, index: number): string =>
  `${index}-${citation.file_id}-${citation.start_page}`;
